import { regex, required } from 'react-admin';

export const canonicalDomainRegex = /^(?!http:|https:|www\.).+\.+.*[^\s]+$/u;

export const validateCanonicalDomain = () => {
  return [
    required(),
    regex(canonicalDomainRegex, 'Domain is not in canonical form (without http/s protocol and www.).'),
  ];
};
